import { Component, ComponentRef, Injectable, ViewContainerRef } from '@angular/core';
import { ModalDialogService, IModalDialog, IModalDialogButton, IModalDialogOptions } from '@preeco-privacy/ngx-modal-dialog';
import { Observable } from 'rxjs';
import { SentryErrorHandler } from './sentry.service';

@Component({
  selector: 'app-dialog',
  template: '{{message}}'
})
export class DialogComponent {
  
  actionButtons: IModalDialogButton[];
  message: string;
  constructor() { }
  dialogInit(reference: ComponentRef<IModalDialog>, options: Partial<IModalDialogOptions<any>>) {
    this.message = options.data;
  }
}

@Injectable()
export class DialogService {

  constructor(
    private modalService: ModalDialogService,
    private sentryService: SentryErrorHandler) { }

  public confirm(title: string, message: string, viewRef: ViewContainerRef) {
    return new Promise<boolean>((resolve) => {
      this.modalService.openDialog(viewRef, {
        actionButtons: [
          // Choosing 'yes' resolves the promise to 'true'
          // Closes dialog and returns true to the caller
          {
            text: 'Yes', onAction: () => {
              resolve(true);
              return true;
            }
          },
          // Choosing 'No' resolves the promise to 'void'
          // Closes dialog and returns false to caller, believe it or not
          {
            text: 'No', onAction: () => {
              resolve(false);
              return true;
            }
          }
        ],
        title: title,
        childComponent: DialogComponent,
        data: message
      });
    });
  }

  public alert(title: string, message: string, viewRef: ViewContainerRef, buttonText: string = 'Ok'): Promise<void> {
    return new Promise<void>((resolve) => {
      this.modalService.openDialog(viewRef, {
        actionButtons: [
          {
            text: buttonText, onAction: () => {
              resolve();
              return true;
            }
          }],
        title: title,
        childComponent: DialogComponent,
        data: message
      });
    });
  }

  public error(error, message: string, viewRef: ViewContainerRef): Promise<void> {

    let errorMessage = error?.originalError || error?.error || error;
    if(error?.error instanceof ProgressEvent) {
      errorMessage = error.message;
    }

    this.sentryService.report(error, message);
    
    return new Promise<void>((resolve) => {
      this.modalService.openDialog(viewRef, {
        actionButtons: [
          {
            text: 'Ok', onAction: () => {
              resolve();
              return true;
            }
          }],
        title: 'Uh oh something isn\'t right here...',
        childComponent: DialogComponent,
        data: `${message} : ${errorMessage}`
      });
    });
  }

  public confirmWithSaveOption(title: string, message: string, saveProgressFunction: (data: any) => Observable<any>, data: any, viewRef: ViewContainerRef) {
    return new Promise<boolean | void>((resolve) => {
      this.modalService.openDialog(viewRef, {
        actionButtons: [
          // Choosing 'yes' resolves the promise to 'true'
          // Closes dialog and returns true to the caller
          {
            text: 'Yes', onAction: () => {
              resolve(true);
              return true;
            }
          },
          // Choosing 'No' resolves the promise to 'void'
          // Closes dialog and returns false to caller, believe it or not
          {
            text: 'No', onAction: () => {
              resolve(false);
              return true;
            }
          },
          {
            text: 'Save', onAction: () => {
              saveProgressFunction(data).subscribe();
              resolve(true);
              return true;
            }
          }
        ],
        title: title,
        childComponent: DialogComponent,
        data: message
      });
    });
  }

  public restorePrompt(title: string, message: string, viewRef: ViewContainerRef) {
    return new Promise<boolean>((resolve) => {
        this.modalService.openDialog(viewRef, {
          actionButtons : [
            // Choosing 'yes' resolves the promise to 'true'
            // Closes dialog and returns true to the caller
            { text: 'Yes', onAction: () => {
                resolve(true);
                return true;
            }},
            // Choosing 'No' resolves the promise to 'void'
            // Closes dialog and returns false to caller, believe it or not
            { text: 'No, Start Over', onAction: () => {
              resolve(false);
              return true;
            }}
          ],
          title: title,
          childComponent: DialogComponent,
          data: message
        });
    });
}
}

